export default __webpack_public_path__ + "static/media/ideas.cef84573.svg";